<template>
  <div class="profile h-100">
    <transition name="slide-fade">
      <router-view></router-view>
    </transition>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
export default {
  mounted () {
    this.setNavVisible(false)
  },
  methods: {
    ...mapMutations({
      setNavVisible: 'app/setNavVisible'
    })
  }
}
</script>
<style lang="scss">
.profile {
  .save-btn {
    display: flex;
    color: #fff;
    background-image: linear-gradient(101deg, #4295ee, #3573b7);
    justify-content: space-between;
    svg {
      width: 24px;
      height: 24px;
    }
  }
}
</style>
